import React from 'react';

interface ILoaderProps {
  fullScreen?: boolean;
  style?: any
}
export default function Loader(props: ILoaderProps) {
  return (
    <div className="loader-container" style={props.fullScreen ? {
      minHeight: '100dvh',
      width: '100%'
    }: {}}>
      <div className="loader" style={props.style}></div>
    </div>
  )
}